import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-add-vehicle-popup',
  templateUrl: './add-vehicle-popup.component.html',
  styleUrls: ['./add-vehicle-popup.component.scss'],
})
export class AddVehiclePopupComponent implements OnInit {

  constructor(private popoverCtrl: PopoverController, private router: Router) { }

  ngOnInit() {}

  close() {
    this.popoverCtrl.dismiss();
  }

  navigateToAddVehicle() {
    this.popoverCtrl.dismiss();
    this.router.navigate(['/add-vehicle']);
  }

}
